import { ChevronLeftIcon } from 'lucide-react';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

import type { WizardStep } from '../types';

type WizardFooterProps = {
  canContinue: boolean;
  canUpload: boolean;
  isBusy: boolean;
  step: WizardStep;
  onBack: () => void;
  onCancel: () => void;
  onContinue: () => void;
  onUpload: () => void;
};

export const WizardFooter: FC<WizardFooterProps> = ({
  canContinue,
  canUpload,
  isBusy,
  step,
  onBack,
  onCancel,
  onContinue,
  onUpload,
}) => {
  const { t } = useTranslation();

  if (step === 1) {
    return (
      <div className="mt-auto grid grid-cols-2 gap-3 border-t px-6 py-4">
        <Button
          type="button"
          variant="outline"
          color="primary"
          size="lg"
          className="text-base font-semibold"
          disabled={isBusy}
          onClick={onCancel}
        >
          {t('cancel')}
        </Button>
        <Button
          type="button"
          size="lg"
          className="text-base font-semibold"
          disabled={!canContinue}
          onClick={onContinue}
        >
          {t('continue')}
        </Button>
      </div>
    );
  }

  if (step === 2) {
    return (
      <div className="mt-auto grid grid-cols-[10rem_1fr] gap-3 border-t px-6 py-4">
        <Button
          type="button"
          variant="outline"
          color="primary"
          size="lg"
          className="gap-2 text-base font-semibold"
          disabled={isBusy}
          onClick={onBack}
        >
          <ChevronLeftIcon className="size-5" />
          {t('back')}
        </Button>
        <Button
          type="button"
          size="lg"
          className="text-base font-semibold"
          disabled={!canUpload}
          loading={isBusy}
          onClick={onUpload}
        >
          {t('continue')}
        </Button>
      </div>
    );
  }

  return null;
};
